import {useInfiniteQuery} from '@tanstack/react-query'
import {PROFILE_API} from '../services/profile.http'
import {QUERY_KEYS} from './keys'
import {MURAL_TYPES} from '../services/completeProfile.schema'

export const useGetMuralOfHost = ({
    hostID,
    enabled = true,
    limit = 10,
    muralType
}: {
    hostID?: number | string
    enabled?: boolean
    limit?: number
    muralType?: MURAL_TYPES
}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.mural_of_host, hostID, muralType],
        queryFn: ({pageParam: page}) => PROFILE_API.getMuralOfHost({hostID, page, limit, muralType}),
        enabled,
        initialPageParam: '1',
        getNextPageParam: ({meta}) => (meta.page !== meta.totalPages ? `${meta.page + 1}` : undefined)
    })
    return {...query, isEmptyList: !query.data?.pages.at(-1)?.data.length}
}
